"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/Room/History/Mobile/SessionsListSection.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _helpers = require('web/components/VideoRooms/Room/History/helpers');








const SessionsListSection = ({ title, sessionsList, onSessionPick }) => !sessionsList.length
  ? null
  : (
    _react2.default.createElement('div', { className: "meeting-room--mobile-history--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}
      , _react2.default.createElement('h5', { className: "meeting-room--mobile-history--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}, title)
      , 
        sessionsList.map(s => {
          const { startedAt, duration } = _helpers.formatTimingLabels.call(void 0, s.StartedAt, s.EndedAt)
          const roomUsersCount = s.RoomUsers && s.RoomUsers.length || 0
          const roomUsersLabel = roomUsersCount === 1
            ? '1 participant'
            : `${roomUsersCount} participants`

          return (
            _react2.default.createElement('div', {
              key: s.RoomSessionKey,
              onClick: () => onSessionPick(s.RoomSessionKey),
              className: "meeting-room--mobile-history--section-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}

              , _react2.default.createElement('div', { className: "meeting-room--mobile-history--item-main-col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
                , _react2.default.createElement('span', { className: "meeting-room--mobile-history--meeting-participants", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
                  ,  roomUsersLabel 
                )
                , _react2.default.createElement('span', { className: "meeting-room--mobile-history--meeting-duration", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
                  ,  duration 
                )
              )
              , _react2.default.createElement('div', { className: "meeting-room--mobile-history--item-desc-col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
                , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 39}},  startedAt )
              )
              , _react2.default.createElement('div', { className: "meeting-room--mobile-history--item-more-col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
                , _react2.default.createElement('img', { src: "/assets/icons/video/forward-grey.svg", alt: ">", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}} )
              )
            )
          )
        })
      
    )
    )

exports. default = SessionsListSection
